<template>
<div class="RowComments">
  <comments 
    :comments="list" 
    :isCanAdd="isCanAdd"
    @submitComment="submitComment($event)" />
</div>
</template>
<script>
import Comments from './Comments';
import db from '@/services/db'
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  components: {
    Comments
  },
  props: {
    rowKey: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      list: [],
      isCanAdd: true
    }
  },
  mounted() {
    this.updateCommentsList();
    // db.comments.deleteAll();
  },
  computed: {
    ...mapState([
      'comments'
    ]),
    ...mapGetters([
      'getRecordComments'
    ])
  },
  watch: {
    comments() {
      this.updateCommentsList();
    }
  },
  methods: {
    ...mapActions([
      'addComment'
    ]),
    submitComment(comment) {
      comment.record = this.rowKey;
      this.addComment(comment);
    },
    updateCommentsList() {
      this.list = this.getRecordComments(this.rowKey);
    }
  }
}
</script>

<style>
  .RowComments {
    display: block;
    width: 100%;
  }
</style>
